import ExpandCircleDownOutlinedIcon from "@mui/icons-material/ExpandCircleDownOutlined";
import React, { useState } from "react";
import { MuiBox, MuiTypography } from "..";
import { LoadMoreListWrapper } from "./LoadMoreList.style";

type LoadMoreListProps<T> = {
  readonly items: readonly T[];
  readonly renderItem: (item: T) => React.ReactNode;
  readonly initialCount?: number;
  readonly incrementCount?: number;
};

export const LoadMoreList = <T,>({
  items,
  renderItem,
  initialCount = 10,
  incrementCount = 10,
}: LoadMoreListProps<T>): React.JSX.Element => {
  const [visibleCount, setVisibleCount] = useState(initialCount);

  const visibleItems = items.slice(0, visibleCount);
  const hasMore = visibleCount < items.length;

  const handleLoadMore = () => {
    setVisibleCount((prev) => prev + incrementCount);
  };

  return (
    <LoadMoreListWrapper>
      {visibleItems.map(renderItem)}

      {hasMore && (
        <MuiBox className="load-more-container">
          <MuiBox
            onClick={handleLoadMore}
            data-testid="load-more-button"
            className="load-more-button"
          >
            <ExpandCircleDownOutlinedIcon />
            <MuiTypography className="h3SemiBold">Load More</MuiTypography>
          </MuiBox>
        </MuiBox>
      )}
    </LoadMoreListWrapper>
  );
};
